const calculators = document.querySelectorAll<HTMLElement>('.js-calculate-total');

function calculateRowTotal(row: HTMLElement): number {
  const input = row.querySelector<HTMLInputElement>('.js-calculator-input');
  const totalCell = row.querySelector<HTMLTableCellElement>('.js-calculator-total-cell');

  if (input && totalCell) {
    const price = Number.parseFloat(input.dataset.price ?? '0');
    const quantity = Number.parseFloat(input.value) || 0;
    const result = price * quantity;

    totalCell.textContent = `${result.toLocaleString('ru-RU')} ₽`;
    return result;
  }

  return 0;
}

function calculateTotal(table: HTMLElement): void {
  let total = 0;

  const rows = table.querySelectorAll<HTMLTableRowElement>('.js-calculator-line');
  for (const row of rows) {
    total += calculateRowTotal(row);
  }

  const totalElement = table.querySelector<HTMLInputElement>('[name="total"]');
  const totalCellInFooter = table.querySelector<HTMLSpanElement>('.js-calculator-line-total');

  if (totalCellInFooter && totalElement) {
    totalCellInFooter.textContent = `${total.toLocaleString('ru-RU')}`;
    totalElement.value = `${total}`;
  }
}

for (const calculator of calculators) {
  const inputs = calculator.querySelectorAll<HTMLInputElement>('.js-calculator-input');
  for (const input of inputs) {
    input.addEventListener('input', () => {
      const row = input.closest<HTMLElement>('.js-calculator-line');
      if (row) {
        calculateRowTotal(row);
      }
      calculateTotal(calculator);
    });
  }
}
